var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3745 26.3809L18.2335 38.679C14.8795 37.2385 12.5145 34.4005 12.2565 31.025L11.7405 24.2524C12.2135 25.0264 12.7725 25.7359 13.3745 26.4024V26.3809Z",
    fill: "#FFC730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.638 24.2524L34.122 31.0035C33.821 34.895 30.7035 38.077 26.5325 39.2165L23.157 30.6379H23.2C28.0375 30.6379 32.273 28.0794 34.638 24.2524Z",
    fill: "#FFC730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.025 17.2435C12.025 11.0809 17.0203 6.08997 23.2 6.08997C29.3798 6.08997 34.375 11.0809 34.375 17.2435C34.375 23.4061 29.3798 28.397 23.2 28.397C17.0203 28.397 12.025 23.4061 12.025 17.2435ZM23.2 9.08997C18.6728 9.08997 15.025 12.7421 15.025 17.2435C15.025 21.7449 18.6728 25.397 23.2 25.397C27.7273 25.397 31.375 21.7449 31.375 17.2435C31.375 12.7421 27.7273 9.08997 23.2 9.08997Z",
    fill: "#03182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00074 18.1847C9.00079 18.1854 9.00069 18.1841 9.00074 18.1847L10.0112 31.1913C10.4563 37.0705 16.08 41.909 23.2 41.909C30.3152 41.909 35.9242 37.0739 36.389 31.1877C36.3891 31.1873 36.389 31.188 36.389 31.1877L37.3992 18.1847C37.3992 18.1841 37.3992 18.1853 37.3992 18.1847C37.9204 11.2263 31.6455 5.005 23.2 5.005C14.7545 5.005 8.4796 11.2263 9.00074 18.1847ZM6.00916 18.4093C5.32756 9.32945 13.4142 2.005 23.2 2.005C32.9858 2.005 41.0724 9.32946 40.3908 18.4093L40.3905 18.4132L39.38 31.4207C38.7692 39.165 31.5644 44.909 23.2 44.909C14.8406 44.909 7.60757 39.1703 7.01985 31.4193C7.01981 31.4188 7.01989 31.4198 7.01985 31.4193L6.00945 18.4132L6.00916 18.4093Z",
    fill: "#03182F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0718 22.9427C16.8427 22.6394 17.7135 23.0184 18.0168 23.7893L25.5203 42.8598C25.8237 43.6307 25.4446 44.5016 24.6737 44.8049C23.9028 45.1082 23.032 44.7292 22.7287 43.9583L15.2252 24.8877C14.9218 24.1168 15.3009 23.246 16.0718 22.9427Z",
    fill: "#03182F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8398 18.099C19.6141 17.8045 20.4805 18.1935 20.775 18.9678C21.1422 19.9333 22.0819 20.624 23.1784 20.624C24.275 20.624 25.2147 19.9333 25.5819 18.9678C25.8763 18.1935 26.7428 17.8045 27.5171 18.099C28.2914 18.3934 28.6804 19.2599 28.386 20.0342C27.5921 22.1217 25.5649 23.624 23.1784 23.624C20.792 23.624 18.7648 22.1217 17.9709 20.0342C17.6765 19.2599 18.0655 18.3934 18.8398 18.099Z",
    fill: "#03182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.8f88c400fda2e043f0e80224f0531fb2.svg";
export { ForwardRef as ReactComponent };